import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/BenimMenu.css";

function BenimMenu() {
    const navigate = useNavigate();

    const kullaniciAdi = localStorage.getItem("userName") || "Personel";

    const menuKartlari = [
        {
            baslik: "Evraklarım",
            aciklama: "Personel evraklarını görüntüle, kontrol et ve gerekli belgelerine ulaş.",
            ikon: "📄",
            buton: "Evraklara Git",
            onClick: () => navigate("/personel/evraklarim"),
        },
        {
            baslik: "Profil Bilgilerim",
            aciklama: "Kişisel bilgilerini, profil fotoğrafını ve hesap detaylarını kontrol et.",
            ikon: "👤",
            buton: "Profili Gör",
            onClick: () => navigate("/profil"),
        },
        {
            baslik: "Hızlı Bilgilendirme",
            aciklama: "Sana özel duyurular ve kısa bilgilendirmeler burada gösterilecek.",
            ikon: "🔔",
            buton: "Yakında",
            disabled: true,
        },
    ];

    return (
        <div className="benim-menu-page">
            <section className="benim-menu-hero">
                <div>
                    <span className="benim-menu-eyebrow">Personel Alanı</span>
                    <h1>Benim Menüm</h1>
                    <p>
                        Merhaba {kullaniciAdi}, buradan sana özel işlemlere hızlıca ulaşabilirsin.
                    </p>
                </div>

                <div className="benim-menu-hero-icon">
                    ✨
                </div>
            </section>

            <section className="benim-menu-grid">
                {menuKartlari.map((kart) => (
                    <div className="benim-menu-card" key={kart.baslik}>
                        <div className="benim-menu-card-icon">
                            {kart.ikon}
                        </div>

                        <div className="benim-menu-card-content">
                            <h3>{kart.baslik}</h3>
                            <p>{kart.aciklama}</p>
                        </div>

                        <button
                            type="button"
                            className="benim-menu-card-btn"
                            onClick={kart.onClick}
                            disabled={kart.disabled}
                        >
                            {kart.buton}
                        </button>
                    </div>
                ))}
            </section>
        </div>
    );
}

export default BenimMenu;